// extracted by mini-css-extract-plugin
export default {"list":"MobileFilterClass_list__XjIB5"};